import React, { Suspense, lazy, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import './App.css'; // Import the CSS file
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react"

const LandingPage = lazy(() => import('./pages/LandingPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const LessonsPage = lazy(() => import('./pages/LessonsPage'));
const MenuPage = lazy(() => import('./pages/MenuPage'));
const UserInfoPage = lazy(() => import('./pages/UserInfoPage'));
const PaymentPage = lazy(() => import('./pages/PaymentPage'));
const EventsPage = lazy(() => import('./pages/EventsPage'));
const AdminLoginPage = lazy(() => import('./pages/AdminLoginPage'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const OwnerDashboard = lazy(() => import('./pages/OwnerDashboard'));
const BookingPage = lazy(() => import('./pages/booking'));

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  return (
    <Router>
      <Navbar />
      <div className="content">
        <Suspense fallback={<div className="route-loading" aria-label="Loading page" />}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/reservations" element={<BookingPage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/lessons" element={<LessonsPage />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/user-info" element={<UserInfoPage />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/admin" element={<AdminLoginPage onLogin={setIsLoggedIn} />} />
            <Route path="/admin/dashboard" element={isLoggedIn ? <AdminDashboard /> : <AdminLoginPage onLogin={setIsLoggedIn} />} />
            <Route path="/owner/dashboard" element={isLoggedIn ? <OwnerDashboard /> : <AdminLoginPage onLogin={setIsLoggedIn} />} />
          </Routes>
        </Suspense>
      </div>
      <SpeedInsights/>
      <Analytics />
    </Router>
  );
}

export default App;
